import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** This represents a Activity */
export type Activity = {
  __typename?: 'Activity';
  amount: Scalars['Int']['output'];
  contractAddress: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['String']['output'];
  event: Scalars['String']['output'];
  from?: Maybe<User>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  network: NftNetwork;
  nft?: Maybe<Nft>;
  nftId?: Maybe<Scalars['Int']['output']>;
  platform: NftPlatform;
  price: Scalars['Float']['output'];
  to?: Maybe<User>;
  toAddress: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['Int']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
};

/** This represents a Article */
export type Article = {
  __typename?: 'Article';
  artist?: Maybe<User>;
  artistId?: Maybe<Scalars['Int']['output']>;
  author: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  excerpt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image1?: Maybe<Scalars['String']['output']>;
  image2?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** This represents a paginated list of articles */
export type ArticlePage = {
  __typename?: 'ArticlePage';
  articles: Array<Article>;
  currentPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** This represents a Auction */
export type Auction = {
  __typename?: 'Auction';
  auctionAddress: Scalars['String']['output'];
  auctionId: Scalars['Int']['output'];
  bids: Array<Bid>;
  commissionBps: Scalars['String']['output'];
  commissionBpsArray: Array<Scalars['Int']['output']>;
  commissionReceivers: Scalars['String']['output'];
  commissionReceiversArray: Array<Scalars['String']['output']>;
  commissionReceiversObjects: Array<Maybe<User>>;
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  minimumIncrement: Scalars['Int']['output'];
  nft?: Maybe<Nft>;
  nftId?: Maybe<Scalars['Int']['output']>;
  reservePrice: Scalars['Float']['output'];
  seller?: Maybe<User>;
  sellerAddress: Scalars['String']['output'];
  sellerId?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  tokenId: Scalars['Int']['output'];
  transactionHash: Scalars['String']['output'];
};

export enum AuctionStatus {
  AuctionStatusCancelled = 'AUCTION_STATUS_CANCELLED',
  AuctionStatusEnded = 'AUCTION_STATUS_ENDED',
  AuctionStatusPending = 'AUCTION_STATUS_PENDING',
  AuctionStatusStarted = 'AUCTION_STATUS_STARTED'
}

/** This represents a Bid */
export type Bid = {
  __typename?: 'Bid';
  auction: Auction;
  auctionId: Scalars['Int']['output'];
  bidPrice: Scalars['Float']['output'];
  bidder?: Maybe<User>;
  bidderAddress: Scalars['String']['output'];
  bidderId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  transactionHash: Scalars['String']['output'];
};

/** This represents a user's billing information */
export type BillingInformation = {
  __typename?: 'BillingInformation';
  address: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  zip: Scalars['String']['output'];
};

export type Collection = {
  __typename?: 'Collection';
  article?: Maybe<Scalars['Int']['output']>;
  articleBody?: Maybe<Article>;
  banner?: Maybe<Scalars['String']['output']>;
  brutto: Scalars['Boolean']['output'];
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  interview?: Maybe<Scalars['Int']['output']>;
  interviewBody?: Maybe<Article>;
  /** Whether at least one artwork in the collection uses compressed media */
  isCompressed: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<CollectionListing>;
  network: NftNetwork;
  nftCount: Scalars['Int']['output'];
  nfts: Array<Nft>;
  owner: User;
  ownerId: Scalars['Int']['output'];
  pass?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: CollectionType;
};


export type CollectionNftsArgs = {
  brutto?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  network?: InputMaybe<NftNetwork>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<CollectionType>>>;
};

export type CollectionListing = {
  __typename?: 'CollectionListing';
  auctionDuration: Scalars['Float']['output'];
  commissionBps: Scalars['String']['output'];
  commissionBpsArray: Array<Scalars['Int']['output']>;
  commissionReceivers: Scalars['String']['output'];
  commissionReceiversArray: Array<Scalars['String']['output']>;
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  endTime: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  marketplaceAddress: Scalars['String']['output'];
  network?: Maybe<Array<Maybe<NftNetwork>>>;
  price: Scalars['Float']['output'];
  sellerAddress: Scalars['String']['output'];
  sellerId?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  transactionHash: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum CollectionType {
  Curated = 'curated',
  Custom = 'custom',
  Standard = 'standard'
}

/** This represents a Contract */
export type Contract = {
  __typename?: 'Contract';
  collectionType: Scalars['String']['output'];
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  creator?: Maybe<User>;
  creatorAddress: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDeployed: Scalars['Boolean']['output'];
  isLinkedToCollection: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  network: NftNetwork;
  nfts: Array<Nft>;
  platform: Scalars['String']['output'];
  royaltyBps?: Maybe<Scalars['Int']['output']>;
  royaltyReceiver?: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
  transactionHash: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum ContractTypes {
  ContractTypeErc721 = 'CONTRACT_TYPE_ERC721',
  ContractTypeErc721Lazymint = 'CONTRACT_TYPE_ERC721LAZYMINT',
  ContractTypeErc721Lazymintyom = 'CONTRACT_TYPE_ERC721LAZYMINTYOM',
  ContractTypeErc1155 = 'CONTRACT_TYPE_ERC1155'
}

/** Input payload for a physical item in an order */
export type CreatePhysicalOrderItemInput = {
  cartItemId?: InputMaybe<Scalars['Int']['input']>;
  physicalId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

/** Result of a physical order creation attempt */
export type CreatePhysicalOrderResult = {
  __typename?: 'CreatePhysicalOrderResult';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  items: Array<PhysicalOrderPurchasableItemResult>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

/** Input payload for editing quantity of a cart item */
export type EditPhysicalCartItemInput = {
  physicalId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

/** This represents a LabsPage */
export type LabsPage = {
  __typename?: 'LabsPage';
  artist?: Maybe<Scalars['String']['output']>;
  artistLink?: Maybe<Scalars['String']['output']>;
  assetType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  object: Scalars['String']['output'];
  orientation: Scalars['String']['output'];
  pageLink?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  screen: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Root Mutation */
export type Mutation = {
  __typename?: 'Mutation';
  /** Add a single item to a user's cart */
  addToCart: Scalars['Boolean']['output'];
  /** Allows an authenticated user to add a wallet address by proving ownership with a signature */
  addWalletAddress?: Maybe<User>;
  /** Allows a user to cancel a lazy order for ERC1155 tokens. The creator must be authenticated */
  cancel1155LazyOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Cancel a waiting physical order owned by the authenticated user */
  cancelPhysicalOrder: Scalars['Boolean']['output'];
  /** Allows a user to create a lazy order for ERC721 tokens. The creator must be authenticated */
  create721LazyOrder?: Maybe<Order>;
  /** Allows a user to create a lazy order for ERC1155 tokens. The creator must be authenticated */
  create1155LazyOrder?: Maybe<Order>;
  /** Creates an article */
  createArticle: Scalars['Int']['output'];
  /** Allows a user to create a collection. The creator must be authenticated */
  createCollection?: Maybe<Collection>;
  /** Allows a user to create a contract. The creator must be authenticated */
  createContract?: Maybe<Contract>;
  /** Allows a user to create an NFT. The creator must be authenticated */
  createNft?: Maybe<Nft>;
  /** Create a physical order and Stripe checkout session */
  createOrder: CreatePhysicalOrderResult;
  /** Creates a physical artwork */
  createPhysical: Scalars['Int']['output'];
  /** Deletes an article */
  deleteArticle: Scalars['Boolean']['output'];
  /** Delete a user's billing information */
  deleteBillingInformation: Scalars['Boolean']['output'];
  /** Allows a user to delete a collection. The user must be authenticated */
  deleteCollection: Scalars['Boolean']['output'];
  /** Allows a user to delete a lazy minted NFT. The creator must be authenticated */
  deleteLazyNft: Scalars['Boolean']['output'];
  /** Deletes a physical artwork */
  deletePhysical: Scalars['Boolean']['output'];
  /** Delete a user's shipping information */
  deleteShippingInformation: Scalars['Boolean']['output'];
  /** Allows a user to edit the initial order for ERC1155 tokens. The creator must be authenticated */
  edit1155InitialOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Edit a user's billing information */
  editBillingInformation: BillingInformation;
  /** Edit quantities of items in a user's cart */
  editCartItems: Scalars['Boolean']['output'];
  /** Edits a physical artwork */
  editOnSale: Scalars['Boolean']['output'];
  /** Edit a user's shipping information */
  editShippingInformation: ShippingInformation;
  /** Allows a user hide and unHide an NFT. The creator must be authenticated */
  hideNft: Scalars['Boolean']['output'];
  /** Mark a Superrare order as internal to know if it was initiated by NINFA interface */
  markSuperrareOrderAsInternal?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a new user to register for a custom project reminder */
  registerForCustomProjectReminder: Scalars['Boolean']['output'];
  /** Reject an offer */
  rejectOffer?: Maybe<Offer>;
  /** Remove items from a user's cart */
  removeFromCart: Scalars['Boolean']['output'];
  /** Resends a fresh 6-digit otp for email verification to the authenticated user */
  resendEmailOtp: Scalars['Boolean']['output'];
  /** Resume payment for an existing waiting physical order */
  resumeOrderPayment: Scalars['String']['output'];
  /** Save a user's billing information */
  saveBillingInformation: BillingInformation;
  /** Save a user's shipping information */
  saveShippingInformation: ShippingInformation;
  /** Allows a new user to sign up */
  signUp?: Maybe<User>;
  /** Updates an article */
  updateArticle: Scalars['Boolean']['output'];
  /** Allows a user to update a collection. The user must be authenticated */
  updateCollection?: Maybe<Collection>;
  /** Allows a user to add or remove NFTs from a collection. The user must be authenticated */
  updateCollectionNfts: Scalars['Boolean']['output'];
  /** Updates a labs page to a curated selection */
  updateLabsPage: Scalars['Boolean']['output'];
  /** Allows a new user to update their newsletter subscription */
  updateNewsletterSubscription: Scalars['Boolean']['output'];
  /** Allows a new user to update their profile, needs auuthentication and autorization. */
  updateUser?: Maybe<User>;
  /** Allows a new user to update their details, needs authentication and autorization. If first time, will create a new user details row in the db */
  updateUserDetails?: Maybe<UserDetails>;
  /** Allows an admin to update a user's type. Needs authentication and authorization. */
  updateUserType: Scalars['Boolean']['output'];
  /** Allows an admin to update a user's yom type. Needs authentication and authorization. */
  updateYomType: Scalars['Boolean']['output'];
  /** Verifies the authenticated user's email by checking the submitted otp */
  verifyEmailOtp: Scalars['Boolean']['output'];
};


/** Root Mutation */
export type MutationAddToCartArgs = {
  physicalId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationAddWalletAddressArgs = {
  signature: Scalars['String']['input'];
  walletAddress: Scalars['String']['input'];
};


/** Root Mutation */
export type MutationCancel1155LazyOrderArgs = {
  id: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationCancelPhysicalOrderArgs = {
  orderId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationCreate721LazyOrderArgs = {
  buyerAddress?: InputMaybe<Scalars['String']['input']>;
  commissionBps?: InputMaybe<Scalars['String']['input']>;
  commissionReceivers?: InputMaybe<Scalars['String']['input']>;
  contractAddress: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  feeAccount?: InputMaybe<Scalars['String']['input']>;
  nftId: Scalars['Int']['input'];
  salt: Scalars['String']['input'];
  sellerAddress: Scalars['String']['input'];
  sellerId: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['Int']['input']>;
  type: OrderTypes;
  unitPrice: Scalars['Float']['input'];
};


/** Root Mutation */
export type MutationCreate1155LazyOrderArgs = {
  amount: Scalars['Int']['input'];
  commissionBps?: InputMaybe<Scalars['String']['input']>;
  commissionReceivers?: InputMaybe<Scalars['String']['input']>;
  contractAddress: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  maxAmount: Scalars['Int']['input'];
  nftId: Scalars['Int']['input'];
  sellerAddress: Scalars['String']['input'];
  sellerId: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
  type: OrderTypes;
  unitPrice: Scalars['Float']['input'];
};


/** Root Mutation */
export type MutationCreateArticleArgs = {
  artistId?: InputMaybe<Scalars['Int']['input']>;
  author: Scalars['String']['input'];
  body: Scalars['String']['input'];
  excerpt: Scalars['String']['input'];
  image1: Scalars['String']['input'];
  image2?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** Root Mutation */
export type MutationCreateCollectionArgs = {
  banner?: InputMaybe<Scalars['String']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  network: NftNetwork;
  ownerId: Scalars['Int']['input'];
  subdomain?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: CollectionType;
};


/** Root Mutation */
export type MutationCreateContractArgs = {
  contractAddress: Scalars['String']['input'];
  creatorAddress: Scalars['String']['input'];
  creatorId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  network: NftNetwork;
  platform: NftPlatform;
  royaltyBps?: InputMaybe<Scalars['Int']['input']>;
  royaltyReceiver?: InputMaybe<Scalars['String']['input']>;
  symbol: Scalars['String']['input'];
  transactionHash: Scalars['String']['input'];
  type: ContractTypes;
};


/** Root Mutation */
export type MutationCreateNftArgs = {
  amount: Scalars['Int']['input'];
  assetType: NftAssetType;
  attributes?: InputMaybe<Scalars['String']['input']>;
  collaborators?: InputMaybe<Scalars['String']['input']>;
  contractAddress: Scalars['String']['input'];
  creatorAddress: Scalars['String']['input'];
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  height: Scalars['Int']['input'];
  hiddenByOGCreator: Scalars['Boolean']['input'];
  imageUrl: Scalars['String']['input'];
  isMinted?: InputMaybe<Scalars['Boolean']['input']>;
  listedOn?: InputMaybe<Array<InputMaybe<NftPlatform>>>;
  listingType?: InputMaybe<NftListingType>;
  metadataUrl: Scalars['String']['input'];
  network: NftNetwork;
  originalImageUrl?: InputMaybe<Scalars['String']['input']>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  platform: NftPlatform;
  price?: InputMaybe<Scalars['Int']['input']>;
  royaltyBps?: InputMaybe<Scalars['Int']['input']>;
  royaltyReceivers?: InputMaybe<Scalars['String']['input']>;
  royaltySplit?: InputMaybe<Scalars['String']['input']>;
  standard: NftStandard;
  title: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['Int']['input']>;
  transactionHash?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationCreateOrderArgs = {
  billingCountry: Scalars['String']['input'];
  billingInformationId?: InputMaybe<Scalars['Int']['input']>;
  billingPhone: Scalars['String']['input'];
  billingTaxCode?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  items: Array<CreatePhysicalOrderItemInput>;
  lastName: Scalars['String']['input'];
  shippingAddress: Scalars['String']['input'];
  shippingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  shippingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  shippingInformationId?: InputMaybe<Scalars['Int']['input']>;
  shippingPhone: Scalars['String']['input'];
  shippingPostalCode?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingTaxCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationCreatePhysicalArgs = {
  assetLink: Scalars['String']['input'];
  availableSupply?: InputMaybe<Scalars['Int']['input']>;
  creatorId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  format?: InputMaybe<PhysicalFormat>;
  formatId?: InputMaybe<Scalars['Int']['input']>;
  imageUrls: Array<PhysicalImageInput>;
  onSale?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  totalSupply?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Mutation */
export type MutationDeleteArticleArgs = {
  id: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationDeleteBillingInformationArgs = {
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationDeleteCollectionArgs = {
  collectionId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationDeleteLazyNftArgs = {
  id: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationDeletePhysicalArgs = {
  id: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationDeleteShippingInformationArgs = {
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationEdit1155InitialOrderArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};


/** Root Mutation */
export type MutationEditBillingInformationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationEditCartItemsArgs = {
  items: Array<EditPhysicalCartItemInput>;
  userId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationEditOnSaleArgs = {
  assetLink?: InputMaybe<Scalars['String']['input']>;
  availableSupply?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<PhysicalFormat>;
  formatId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  imageUrls?: InputMaybe<Array<PhysicalImageInput>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  onSale?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PhysicalStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalSupply?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Mutation */
export type MutationEditShippingInformationArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationHideNftArgs = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};


/** Root Mutation */
export type MutationMarkSuperrareOrderAsInternalArgs = {
  internalOrderId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationRegisterForCustomProjectReminderArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationRejectOfferArgs = {
  id: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationRemoveFromCartArgs = {
  physicalIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationResumeOrderPaymentArgs = {
  orderId: Scalars['Int']['input'];
};


/** Root Mutation */
export type MutationSaveBillingInformationArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  taxCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  zip: Scalars['String']['input'];
};


/** Root Mutation */
export type MutationSaveShippingInformationArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  details: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  taxCode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  zip: Scalars['String']['input'];
};


/** Root Mutation */
export type MutationSignUpArgs = {
  acceptedTerms: Scalars['String']['input'];
  approvedAt?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateArticleArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  image1?: InputMaybe<Scalars['String']['input']>;
  image2?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateCollectionArgs = {
  article?: InputMaybe<Scalars['Int']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  brutto?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  interview?: InputMaybe<Scalars['Int']['input']>;
  isCompressed?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateCollectionNftsArgs = {
  addedNftIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  collectionId: Scalars['Int']['input'];
  removedNftIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** Root Mutation */
export type MutationUpdateLabsPageArgs = {
  assetType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  pageLink?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateNewsletterSubscriptionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  subscribe?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root Mutation */
export type MutationUpdateUserArgs = {
  approvedAt?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  canCreatePhysical?: InputMaybe<Scalars['Boolean']['input']>;
  detailsFilled?: InputMaybe<Scalars['Boolean']['input']>;
  discord?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  onCyberLink?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  stripeConnectId?: InputMaybe<Scalars['String']['input']>;
  termsAcceptedAt?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateUserDetailsArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  emailSettings?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unicode?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateUserTypeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationUpdateYomTypeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  yomType?: InputMaybe<Scalars['String']['input']>;
};


/** Root Mutation */
export type MutationVerifyEmailOtpArgs = {
  otp: Scalars['String']['input'];
};

/** This represents an Nft */
export type Nft = {
  __typename?: 'Nft';
  activities: Array<Activity>;
  amount: Scalars['Int']['output'];
  assetType: Scalars['String']['output'];
  attributes?: Maybe<Array<Maybe<NftAttributes>>>;
  auctions: Array<Auction>;
  collaborators?: Maybe<Scalars['String']['output']>;
  collections: Array<Collection>;
  contract?: Maybe<Contract>;
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  creators: Array<NftCreator>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  hiddenByOGCreator: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isBurnt: Scalars['Boolean']['output'];
  isCompressed: Scalars['Boolean']['output'];
  isCuratedPick: Scalars['Boolean']['output'];
  isFeaturedArtist: Scalars['Boolean']['output'];
  isMinted: Scalars['Boolean']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  listedOn?: Maybe<Scalars['String']['output']>;
  listingType: Scalars['String']['output'];
  metadataUrl: Scalars['String']['output'];
  minimumOffer: Scalars['Float']['output'];
  network: NftNetwork;
  offers: Array<Offer>;
  ogCreator?: Maybe<User>;
  orders: Array<Order>;
  originalImageUrl?: Maybe<Scalars['String']['output']>;
  owners: Array<NftOwner>;
  platform: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  royaltyBps?: Maybe<Scalars['Int']['output']>;
  royaltyReceivers?: Maybe<Scalars['String']['output']>;
  royaltySplit?: Maybe<Scalars['String']['output']>;
  seeAlso: Array<Nft>;
  standard: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['Int']['output']>;
  trades: Array<Trade>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};


/** This represents an Nft */
export type NftOwnersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
};

export enum NftAssetType {
  AssetTypeGif = 'ASSET_TYPE_GIF',
  AssetTypeHtml = 'ASSET_TYPE_HTML',
  AssetTypeImage = 'ASSET_TYPE_IMAGE',
  AssetTypeVideo = 'ASSET_TYPE_VIDEO'
}

/** This represents the attributes of an NFT */
export type NftAttributes = {
  __typename?: 'NftAttributes';
  attribute: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** This represents an NftCreator */
export type NftCreator = {
  __typename?: 'NftCreator';
  creator?: Maybe<User>;
  creatorAddress: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['Int']['output']>;
  hidden: Scalars['Boolean']['output'];
  isOG: Scalars['Boolean']['output'];
};

export enum NftListingType {
  ListingTypeAuction = 'LISTING_TYPE_AUCTION',
  ListingTypeAuctionended = 'LISTING_TYPE_AUCTIONENDED',
  ListingTypeAuctionstarted = 'LISTING_TYPE_AUCTIONSTARTED',
  ListingTypeFixedprice = 'LISTING_TYPE_FIXEDPRICE',
  ListingTypeNotforsale = 'LISTING_TYPE_NOTFORSALE'
}

export enum NftMarket {
  MarketPrimary = 'MARKET_PRIMARY',
  MarketSecondary = 'MARKET_SECONDARY'
}

export enum NftNetwork {
  Network_1 = 'NETWORK_1',
  Network_360 = 'NETWORK_360',
  Network_8453 = 'NETWORK_8453',
  Network_11011 = 'NETWORK_11011',
  Network_42161 = 'NETWORK_42161',
  Network_84532 = 'NETWORK_84532',
  Network_421614 = 'NETWORK_421614',
  Network_11155111 = 'NETWORK_11155111'
}

/** This represents an NftOwner */
export type NftOwner = {
  __typename?: 'NftOwner';
  amount: Scalars['Int']['output'];
  hidden: Scalars['Boolean']['output'];
  owner?: Maybe<User>;
  ownerAddress: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['Int']['output']>;
};

/** This represents a page of Nfts */
export type NftPage = {
  __typename?: 'NftPage';
  currentPage: Scalars['Int']['output'];
  nfts: Array<Nft>;
  totalPages: Scalars['Int']['output'];
};

export enum NftPlatform {
  PlatformManifold = 'PLATFORM_MANIFOLD',
  PlatformNinfa = 'PLATFORM_NINFA',
  PlatformSuperrare = 'PLATFORM_SUPERRARE',
  PlatformTransient = 'PLATFORM_TRANSIENT',
  PlatformUnknown = 'PLATFORM_UNKNOWN'
}

export enum NftStandard {
  Standard_721 = 'STANDARD_721',
  Standard_1155 = 'STANDARD_1155'
}

/** This represents a Offer */
export type Offer = {
  __typename?: 'Offer';
  amount: Scalars['Int']['output'];
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  marketplaceAddress: Scalars['String']['output'];
  nft?: Maybe<Nft>;
  nftId?: Maybe<Scalars['Int']['output']>;
  offerId: Scalars['Int']['output'];
  offerPrice: Scalars['Float']['output'];
  offerer?: Maybe<User>;
  offererAddress: Scalars['String']['output'];
  offererId?: Maybe<Scalars['Int']['output']>;
  receiver?: Maybe<User>;
  receiverAddress?: Maybe<Scalars['String']['output']>;
  receiverId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  tokenId: Scalars['Int']['output'];
  transactionHash: Scalars['String']['output'];
};

export enum OfferStatus {
  OfferStatusAccepted = 'OFFER_STATUS_ACCEPTED',
  OfferStatusCancelled = 'OFFER_STATUS_CANCELLED',
  OfferStatusPending = 'OFFER_STATUS_PENDING',
  OfferStatusRejected = 'OFFER_STATUS_REJECTED'
}

/** This represents a Order */
export type Order = {
  __typename?: 'Order';
  amount: Scalars['Int']['output'];
  buyerAddress?: Maybe<Scalars['String']['output']>;
  commissionBps: Scalars['String']['output'];
  commissionBpsArray: Array<Scalars['Int']['output']>;
  commissionReceivers: Scalars['String']['output'];
  commissionReceiversArray: Array<Scalars['String']['output']>;
  commissionReceiversObjects: Array<Maybe<User>>;
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  feeAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isInternal: Scalars['String']['output'];
  marketplaceAddress?: Maybe<Scalars['String']['output']>;
  maxAmount?: Maybe<Scalars['Int']['output']>;
  nft?: Maybe<Nft>;
  nftId?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  referrerAddress?: Maybe<Scalars['String']['output']>;
  salt?: Maybe<Scalars['String']['output']>;
  seller?: Maybe<User>;
  sellerAddress: Scalars['String']['output'];
  sellerId?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['Int']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

export enum OrderStatus {
  OrderStatusActive = 'ORDER_STATUS_ACTIVE',
  OrderStatusCancelled = 'ORDER_STATUS_CANCELLED',
  OrderStatusCancelledonchain = 'ORDER_STATUS_CANCELLEDONCHAIN'
}

export enum OrderTypes {
  OrderTypeEditioninitial = 'ORDER_TYPE_EDITIONINITIAL',
  OrderTypeLazy = 'ORDER_TYPE_LAZY',
  OrderTypeLazyedition = 'ORDER_TYPE_LAZYEDITION',
  OrderTypeOnchain = 'ORDER_TYPE_ONCHAIN'
}

/** This represents a physical artwork */
export type Physical = {
  __typename?: 'Physical';
  assetLink?: Maybe<Scalars['String']['output']>;
  availableSupply: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  format: PhysicalFormat;
  formatId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageUrls: Array<PhysicalImage>;
  isCurrent: Scalars['Boolean']['output'];
  onSale: Scalars['Boolean']['output'];
  physicalFormat?: Maybe<PhysicalFormatDetails>;
  price: Scalars['Float']['output'];
  status: PhysicalStatus;
  title: Scalars['String']['output'];
  totalSupply: Scalars['Int']['output'];
};

/** This represents an item in a user's physical cart */
export type PhysicalCartItem = {
  __typename?: 'PhysicalCartItem';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  physical?: Maybe<Physical>;
  physicalId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/** This represents a paginated cart response */
export type PhysicalCartItemsPage = {
  __typename?: 'PhysicalCartItemsPage';
  currentPage: Scalars['Int']['output'];
  items: Array<PhysicalCartItem>;
  totalPages: Scalars['Int']['output'];
};

export enum PhysicalFormat {
  BigPrint = 'bigPrint',
  Plexiglas = 'plexiglas',
  Print = 'print'
}

/** Display and default purchase data for a physical format */
export type PhysicalFormatDetails = {
  __typename?: 'PhysicalFormatDetails';
  createdAt: Scalars['String']['output'];
  dimensions: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  totalSupply: Scalars['Int']['output'];
};

/** This represents a physical image */
export type PhysicalImage = {
  __typename?: 'PhysicalImage';
  height: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

/** Input payload for a physical image */
export type PhysicalImageInput = {
  height: Scalars['Int']['input'];
  imageUrl: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

/** This represents a physical order */
export type PhysicalOrder = {
  __typename?: 'PhysicalOrder';
  billingInformation?: Maybe<BillingInformation>;
  billingInformationId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  items: Array<PhysicalOrderItem>;
  lastName: Scalars['String']['output'];
  shippingAddress: Scalars['String']['output'];
  shippingInformation?: Maybe<ShippingInformation>;
  shippingInformationId?: Maybe<Scalars['Int']['output']>;
  shippingPrice: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  stripeCheckoutSessionId: Scalars['String']['output'];
  tax: Scalars['Float']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/** This represents an item in a physical order */
export type PhysicalOrderItem = {
  __typename?: 'PhysicalOrderItem';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  physical?: Maybe<Physical>;
  physicalId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

/** This represents a page of physical orders */
export type PhysicalOrderPage = {
  __typename?: 'PhysicalOrderPage';
  currentPage: Scalars['Int']['output'];
  orders: Array<PhysicalOrder>;
  totalPages: Scalars['Int']['output'];
};

/** Purchasability status for one requested physical item */
export type PhysicalOrderPurchasableItemResult = {
  __typename?: 'PhysicalOrderPurchasableItemResult';
  availableSupply: Scalars['Int']['output'];
  isPurchasable: Scalars['Boolean']['output'];
  physicalId: Scalars['Int']['output'];
  requestedQuantity: Scalars['Int']['output'];
};

export enum PhysicalOrderStatus {
  PhysicalOrderStatusCancelled = 'PHYSICAL_ORDER_STATUS_CANCELLED',
  PhysicalOrderStatusDelivered = 'PHYSICAL_ORDER_STATUS_DELIVERED',
  PhysicalOrderStatusExpired = 'PHYSICAL_ORDER_STATUS_EXPIRED',
  PhysicalOrderStatusPaymentfailed = 'PHYSICAL_ORDER_STATUS_PAYMENTFAILED',
  PhysicalOrderStatusProcessing = 'PHYSICAL_ORDER_STATUS_PROCESSING',
  PhysicalOrderStatusShipped = 'PHYSICAL_ORDER_STATUS_SHIPPED',
  PhysicalOrderStatusWaitingforpayment = 'PHYSICAL_ORDER_STATUS_WAITINGFORPAYMENT'
}

/** This represents a paginated list of physical artworks */
export type PhysicalPage = {
  __typename?: 'PhysicalPage';
  currentPage: Scalars['Int']['output'];
  physicals: Array<Physical>;
  totalPages: Scalars['Int']['output'];
};

export enum PhysicalStatus {
  Hidden = 'hidden',
  Published = 'published',
  WaitingForApproval = 'waitingForApproval'
}

/** Root Query */
export type Query = {
  __typename?: 'Query';
  /** A single Article */
  article?: Maybe<Article>;
  /** A paginated list of Articles */
  articles: ArticlePage;
  /** An Auction */
  auction?: Maybe<Auction>;
  /** A list of Auctions with filters */
  auctions: Array<Auction>;
  /** A Collection */
  collection?: Maybe<Collection>;
  /** A list of Collections */
  collections: Array<Collection>;
  /** A Contract */
  contract?: Maybe<Contract>;
  /** A list of Contracts */
  contracts: Array<Contract>;
  /** Get a user's billing information */
  getBillingInformation: Array<BillingInformation>;
  /** Get a paginated cart for a user */
  getCart: PhysicalCartItemsPage;
  /** Get a physical by id */
  getPhysical?: Maybe<Physical>;
  /** Get display data and defaults for a physical format */
  getPhysicalFormat?: Maybe<PhysicalFormatDetails>;
  /** Get all physical format display data and defaults */
  getPhysicalFormats: Array<PhysicalFormatDetails>;
  /** Get a physical order by id */
  getPhysicalOrder?: Maybe<PhysicalOrder>;
  /** Get a user's physical orders */
  getPhysicalOrders: PhysicalOrderPage;
  /** Get physical artworks with pagination */
  getPhysicalsPage: PhysicalPage;
  /** Get a user's shipping information */
  getShippingInformation: Array<ShippingInformation>;
  /** Every LabsPage */
  labs: Array<LabsPage>;
  /** A LabsPage */
  labsPage: Array<LabsPage>;
  /** An Nft */
  nft?: Maybe<Nft>;
  /** A list of Nfts with filters */
  nfts: Array<Nft>;
  /** A list of Nfts with filters with pagination */
  nftsPage: NftPage;
  /** An Offer */
  offer?: Maybe<Offer>;
  /** A list of Offers with filters */
  offers: Array<Offer>;
  /** An Order */
  order?: Maybe<Order>;
  /** A list of Orders with filters */
  orders: Array<Order>;
  /** A list of Nfts searched by title, creator username or creator wallet address */
  searchNfts: Array<Nft>;
  /** Search physical artworks by title */
  searchPhysical: Array<Physical>;
  /** A Trade */
  trade?: Maybe<Trade>;
  /** A list of Trades with filters */
  trades: Array<Trade>;
  /** A Single User */
  user?: Maybe<User>;
  /** A Single User */
  userDetails?: Maybe<UserDetails>;
  /** A list of Users */
  users: Array<User>;
};


/** Root Query */
export type QueryArticleArgs = {
  id: Scalars['Int']['input'];
};


/** Root Query */
export type QueryArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query */
export type QueryAuctionArgs = {
  auctionAddress: Scalars['String']['input'];
  auctionId: Scalars['Int']['input'];
};


/** Root Query */
export type QueryAuctionsArgs = {
  auctionAddress?: InputMaybe<Scalars['String']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nftId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sellerAddress?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<AuctionStatus>>>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query */
export type QueryCollectionsArgs = {
  brutto?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  network?: InputMaybe<NftNetwork>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<CollectionType>>>;
};


/** Root Query */
export type QueryContractArgs = {
  contractAddress?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query */
export type QueryContractsArgs = {
  creatorAddress?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  network?: InputMaybe<Array<InputMaybe<NftNetwork>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Array<InputMaybe<NftPlatform>>>;
  type?: InputMaybe<Array<InputMaybe<ContractTypes>>>;
};


/** Root Query */
export type QueryGetBillingInformationArgs = {
  userId: Scalars['Int']['input'];
};


/** Root Query */
export type QueryGetCartArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


/** Root Query */
export type QueryGetPhysicalArgs = {
  id: Scalars['Int']['input'];
};


/** Root Query */
export type QueryGetPhysicalFormatArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryGetPhysicalOrderArgs = {
  id: Scalars['Int']['input'];
};


/** Root Query */
export type QueryGetPhysicalOrdersArgs = {
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<PhysicalOrderStatus>>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryGetPhysicalsPageArgs = {
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Array<InputMaybe<PhysicalFormat>>>;
  formatId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<PhysicalStatus>>>;
};


/** Root Query */
export type QueryGetShippingInformationArgs = {
  userId: Scalars['Int']['input'];
};


/** Root Query */
export type QueryLabsPageArgs = {
  screen?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryNftArgs = {
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  standard?: InputMaybe<NftStandard>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryNftsArgs = {
  assetType?: InputMaybe<Array<InputMaybe<NftAssetType>>>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  creatorAddress?: InputMaybe<Scalars['String']['input']>;
  creatorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listedOn?: InputMaybe<Array<InputMaybe<NftPlatform>>>;
  listingType?: InputMaybe<Array<InputMaybe<NftListingType>>>;
  market?: InputMaybe<Array<InputMaybe<NftMarket>>>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  network?: InputMaybe<Array<InputMaybe<NftNetwork>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  platform?: InputMaybe<Array<InputMaybe<NftPlatform>>>;
  shape?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showInCollection?: InputMaybe<Scalars['Boolean']['input']>;
  standard?: InputMaybe<Array<InputMaybe<NftStandard>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query */
export type QueryNftsPageArgs = {
  assetType?: InputMaybe<Array<InputMaybe<NftAssetType>>>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  creatorAddress?: InputMaybe<Scalars['String']['input']>;
  creatorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listedOn?: InputMaybe<Array<InputMaybe<NftPlatform>>>;
  listingType?: InputMaybe<Array<InputMaybe<NftListingType>>>;
  market?: InputMaybe<Array<InputMaybe<NftMarket>>>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  network?: InputMaybe<Array<InputMaybe<NftNetwork>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  platform?: InputMaybe<Array<InputMaybe<NftPlatform>>>;
  shape?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showInCollection?: InputMaybe<Scalars['Boolean']['input']>;
  standard?: InputMaybe<Array<InputMaybe<NftStandard>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query */
export type QueryOfferArgs = {
  marketplaceAddress: Scalars['String']['input'];
  offerId: Scalars['Int']['input'];
};


/** Root Query */
export type QueryOffersArgs = {
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketplaceAddress?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  nftId?: InputMaybe<Scalars['Int']['input']>;
  offererAddress?: InputMaybe<Scalars['String']['input']>;
  offererId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  receiverAddress?: InputMaybe<Scalars['String']['input']>;
  receiverId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<OfferStatus>>>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryOrderArgs = {
  marketplaceAddress: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


/** Root Query */
export type QueryOrdersArgs = {
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marketplaceAddress?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  maxUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  minUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  nftId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sellerAddress?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatus>>>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<InputMaybe<OrderTypes>>>;
};


/** Root Query */
export type QuerySearchNftsArgs = {
  search: Scalars['String']['input'];
};


/** Root Query */
export type QuerySearchPhysicalArgs = {
  search: Scalars['String']['input'];
};


/** Root Query */
export type QueryTradeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryTradesArgs = {
  buyerAddress?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  contractAddress?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isVolume?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  network?: InputMaybe<Array<InputMaybe<NftNetwork>>>;
  nftId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sellerAddress?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['Int']['input']>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
  tradeType?: InputMaybe<Array<InputMaybe<TradeTypes>>>;
};


/** Root Query */
export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
};


/** Root Query */
export type QueryUserDetailsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Query */
export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Array<InputMaybe<UserType>>>;
};

/** This represents a user's shipping information */
export type ShippingInformation = {
  __typename?: 'ShippingInformation';
  address: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  details: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  taxCode?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  zip: Scalars['String']['output'];
};

/** This represents a Trade */
export type Trade = {
  __typename?: 'Trade';
  amount: Scalars['Int']['output'];
  brando: Scalars['Float']['output'];
  buyer?: Maybe<User>;
  buyerAddress: Scalars['String']['output'];
  buyerId?: Maybe<Scalars['Int']['output']>;
  carlo: Scalars['Float']['output'];
  commissions: Scalars['Float']['output'];
  contractAddress: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  ethToUsd: Scalars['Float']['output'];
  eurToUsd: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  isSecondary: Scalars['String']['output'];
  isVolume: Scalars['String']['output'];
  lorenzo: Scalars['Float']['output'];
  network: NftNetwork;
  nft?: Maybe<Nft>;
  nftId?: Maybe<Scalars['Int']['output']>;
  ninfaFee: Scalars['Float']['output'];
  platform: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  royaltyFee: Scalars['Float']['output'];
  seller?: Maybe<User>;
  sellerAddress: Scalars['String']['output'];
  sellerId?: Maybe<Scalars['Int']['output']>;
  sellerRevenue: Scalars['Float']['output'];
  tokenId: Scalars['Int']['output'];
  tradeType: Scalars['String']['output'];
  transactionHash: Scalars['String']['output'];
};

export enum TradeTypes {
  TradeTypesAuction = 'TRADE_TYPES_AUCTION',
  TradeTypesMint = 'TRADE_TYPES_MINT',
  TradeTypesOffer = 'TRADE_TYPES_OFFER',
  TradeTypesOrder = 'TRADE_TYPES_ORDER'
}

/** This represents a generic user without considering the userType */
export type User = {
  __typename?: 'User';
  activities: Array<Activity>;
  appliedAt?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  auctions: Array<Auction>;
  bio?: Maybe<Scalars['String']['output']>;
  canCreatePhysical: Scalars['Boolean']['output'];
  collectedNfts: Array<Nft>;
  collections: Array<Collection>;
  contracts: Array<Contract>;
  createYomStep: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdNfts: Array<Nft>;
  details?: Maybe<UserDetails>;
  detailsFilled: Scalars['Boolean']['output'];
  discord?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  isDomus: Scalars['Boolean']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isTermsAccepted: Scalars['Boolean']['output'];
  kycStatus?: Maybe<Scalars['String']['output']>;
  kycToken?: Maybe<Scalars['String']['output']>;
  lastCreated?: Maybe<Scalars['String']['output']>;
  latestAction: Scalars['String']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  offersMade: Array<Offer>;
  offersReceived: Array<Offer>;
  onCyberLink?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  password?: Maybe<Scalars['String']['output']>;
  physicals: Array<Physical>;
  profileImage?: Maybe<Scalars['String']['output']>;
  purchases: Array<Trade>;
  sales: Array<Trade>;
  status: Scalars['Boolean']['output'];
  stripeConnectId?: Maybe<Scalars['String']['output']>;
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  userType: Scalars['String']['output'];
  username: Scalars['String']['output'];
  walletAddress?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yomType: Scalars['String']['output'];
};


/** This represents a generic user without considering the userType */
export type UserCollectedNftsArgs = {
  showCreated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This represents a generic user without considering the userType */
export type UserCreatedNftsArgs = {
  showInCollection?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This represents a generic user without considering the userType */
export type UserDetails = {
  __typename?: 'UserDetails';
  acceptedPrivacyPolicy?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  emailSettings?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unicode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
  userId: Scalars['Int']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export enum UserType {
  UserTypeAdmin = 'USER_TYPE_ADMIN',
  UserTypeArtist = 'USER_TYPE_ARTIST',
  UserTypeCollector = 'USER_TYPE_COLLECTOR',
  UserTypePrinter = 'USER_TYPE_PRINTER'
}

export type UpdateUserTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  userType: Scalars['String']['input'];
}>;


export type UpdateUserTypeMutation = { __typename?: 'Mutation', updateUserType: boolean };

export type UpdateYomTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  yomType: Scalars['String']['input'];
}>;


export type UpdateYomTypeMutation = { __typename?: 'Mutation', updateYomType: boolean };

export type HideNftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  hidden: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
}>;


export type HideNftMutation = { __typename?: 'Mutation', hideNft: boolean };

export type UpdateUserGenreMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  genre?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserGenreMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: number } | null };

export type UpdateCanCreatePhysicalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  canCreatePhysical: Scalars['Boolean']['input'];
}>;


export type UpdateCanCreatePhysicalMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: number, canCreatePhysical: boolean } | null };

export type UpdateLabsPageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  pageLink?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  assetType?: InputMaybe<Scalars['String']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLabsPageMutation = { __typename?: 'Mutation', updateLabsPage: boolean };

export type CreateArticleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  author: Scalars['String']['input'];
  type: Scalars['String']['input'];
  image1: Scalars['String']['input'];
  image2?: InputMaybe<Scalars['String']['input']>;
  artistId?: InputMaybe<Scalars['Int']['input']>;
  body: Scalars['String']['input'];
  excerpt: Scalars['String']['input'];
}>;


export type CreateArticleMutation = { __typename?: 'Mutation', createArticle: number };

export type UpdateArticleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  image1?: InputMaybe<Scalars['String']['input']>;
  image2?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', updateArticle: boolean };

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteArticleMutation = { __typename?: 'Mutation', deleteArticle: boolean };

export type UpdateCollectionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  brutto?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  interview?: InputMaybe<Scalars['Int']['input']>;
  article?: InputMaybe<Scalars['Int']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  isCompressed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'Collection', id: number } | null };

export type EditPhysicalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrls?: InputMaybe<Array<PhysicalImageInput>>;
  totalSupply?: InputMaybe<Scalars['Int']['input']>;
  availableSupply?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  onSale?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  formatId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PhysicalStatus>;
}>;


export type EditPhysicalMutation = { __typename?: 'Mutation', editOnSale: boolean };

export type CreatePhysicalMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  creatorId: Scalars['Int']['input'];
  totalSupply?: InputMaybe<Scalars['Int']['input']>;
  availableSupply?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  formatId?: InputMaybe<Scalars['Int']['input']>;
  imageUrls: Array<PhysicalImageInput>;
  onSale?: InputMaybe<Scalars['Boolean']['input']>;
  assetLink: Scalars['String']['input'];
}>;


export type CreatePhysicalMutation = { __typename?: 'Mutation', createPhysical: number };

export type SignInQueryVariables = Exact<{
  walletAddress: Scalars['String']['input'];
}>;


export type SignInQuery = { __typename?: 'Query', user?: { __typename?: 'User', username: string, email?: string | null, userType: string, walletAddress?: string | null } | null };

export type GetAuthenticatedUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetAuthenticatedUserQuery = { __typename?: 'Query', userDetails?: { __typename?: 'UserDetails', userId: number, user: { __typename?: 'User', id: number, username: string, email?: string | null, userType: string, walletAddress?: string | null } } | null };

export type SearchUsersQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, walletAddress?: string | null, username: string, email?: string | null, userType: string, yomType: string, twitter?: string | null, genre?: string | null, canCreatePhysical: boolean }> };

export type GetArtistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArtistsQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number, walletAddress?: string | null, username: string, email?: string | null, userType: string, yomType: string, twitter?: string | null, genre?: string | null, canCreatePhysical: boolean }> };

export type GetArtistQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetArtistQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, username: string, bio?: string | null } | null };

export type SearchArtworksQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchArtworksQuery = { __typename?: 'Query', searchNfts: Array<{ __typename?: 'Nft', id: number, title: string, description: string, tokenId?: number | null, contractAddress: string, standard: string, platform: string, price: number, listingType: string, listedOn?: string | null, hiddenByOGCreator: boolean, status: boolean, imageUrl: string, assetType: string, width: number, height: number, isCompressed: boolean, ogCreator?: { __typename?: 'User', id: number, username: string, userType: string, walletAddress?: string | null } | null, trades: Array<{ __typename?: 'Trade', id: number, price: number, amount: number }> }> };

export type GetTradesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTradesQuery = { __typename?: 'Query', trades: Array<{ __typename?: 'Trade', id: number, nftId?: number | null, tokenId: number, contractAddress: string, sellerId?: number | null, sellerAddress: string, price: number, amount: number, transactionHash: string, sellerRevenue: number, commissions: number, ninfaFee: number, royaltyFee: number, isSecondary: string, ethToUsd: number, eurToUsd: number, platform: string, network: NftNetwork, tradeType: string, createdAt: string, carlo: number, brando: number, lorenzo: number, nft?: { __typename?: 'Nft', title: string } | null, seller?: { __typename?: 'User', username: string, email?: string | null, legacyId?: number | null, details?: { __typename?: 'UserDetails', firstName?: string | null, lastName?: string | null, type?: string | null, dob?: string | null, nationality?: string | null, region?: string | null, city?: string | null, street?: string | null, postalCode?: string | null, taxId?: string | null, vatNumber?: string | null, unicode?: string | null } | null } | null }> };

export type GetChartsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChartsDataQuery = { __typename?: 'Query', trades: Array<{ __typename?: 'Trade', price: number, ninfaFee: number, ethToUsd: number, amount: number, createdAt: string, network: NftNetwork, carlo: number, brando: number, lorenzo: number }>, users: Array<{ __typename?: 'User', userType: string, createdAt: string, approvedAt?: string | null }>, collections: Array<{ __typename?: 'Collection', type: CollectionType, createdAt: string }> };

export type GetLabsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLabsQuery = { __typename?: 'Query', labs: Array<{ __typename?: 'LabsPage', id: number, screen: number, pageLink?: string | null, image?: string | null, assetType: string, orientation: string }> };

export type GetArticlesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArticlesQuery = { __typename?: 'Query', articles: { __typename?: 'ArticlePage', currentPage: number, totalPages: number, articles: Array<{ __typename?: 'Article', id: number, title: string, author: string, image1?: string | null, image2?: string | null, type: string, createdAt: string, excerpt: string, artist?: { __typename?: 'User', profileImage?: string | null, username: string } | null }> } };

export type GetArticleQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: number, title: string, author: string, image1?: string | null, image2?: string | null, type: string, artistId?: number | null, body: string, createdAt: string, excerpt: string, artist?: { __typename?: 'User', profileImage?: string | null, username: string } | null } | null };

export type GetCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCollectionsQuery = { __typename?: 'Query', collections: Array<{ __typename?: 'Collection', id: number, title: string, description?: string | null, banner?: string | null, type: CollectionType, ownerId: number, network: NftNetwork, createdAt: string, contractAddress?: string | null, subdomain?: string | null, link?: string | null, interview?: number | null, article?: number | null, isCurrent: boolean, brutto: boolean, pass?: string | null, nftCount: number, isCompressed: boolean, owner: { __typename?: 'User', username: string, genre?: string | null } }> };

export type GetPhysicalsPageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  formatId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<PhysicalStatus>>>;
}>;


export type GetPhysicalsPageQuery = { __typename?: 'Query', getPhysicalsPage: { __typename?: 'PhysicalPage', currentPage: number, totalPages: number, physicals: Array<{ __typename?: 'Physical', id: number, title: string, isCurrent: boolean, description: string, totalSupply: number, availableSupply: number, price: number, onSale: boolean, format: PhysicalFormat, formatId?: number | null, status: PhysicalStatus, assetLink?: string | null, createdAt: string, creator?: { __typename?: 'User', username: string } | null, physicalFormat?: { __typename?: 'PhysicalFormatDetails', id: number, name: string, dimensions: string, price: number, totalSupply: number, createdAt: string } | null, imageUrls: Array<{ __typename?: 'PhysicalImage', imageUrl: string, width: number, height: number }> }> } };

export type SearchPhysicalQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchPhysicalQuery = { __typename?: 'Query', searchPhysical: Array<{ __typename?: 'Physical', id: number, title: string, isCurrent: boolean, description: string, totalSupply: number, availableSupply: number, price: number, onSale: boolean, format: PhysicalFormat, formatId?: number | null, status: PhysicalStatus, assetLink?: string | null, createdAt: string, creator?: { __typename?: 'User', username: string } | null, physicalFormat?: { __typename?: 'PhysicalFormatDetails', id: number, name: string, dimensions: string, price: number, totalSupply: number, createdAt: string } | null, imageUrls: Array<{ __typename?: 'PhysicalImage', imageUrl: string, width: number, height: number }> }> };

export type GetPhysicalQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPhysicalQuery = { __typename?: 'Query', getPhysical?: { __typename?: 'Physical', id: number, title: string, isCurrent: boolean, creatorId?: number | null, description: string, totalSupply: number, availableSupply: number, price: number, onSale: boolean, format: PhysicalFormat, formatId?: number | null, status: PhysicalStatus, assetLink?: string | null, createdAt: string, creator?: { __typename?: 'User', username: string } | null, physicalFormat?: { __typename?: 'PhysicalFormatDetails', id: number, name: string, dimensions: string, price: number, totalSupply: number, createdAt: string } | null, imageUrls: Array<{ __typename?: 'PhysicalImage', imageUrl: string, width: number, height: number }> } | null };

export type GetPhysicalFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPhysicalFormatsQuery = { __typename?: 'Query', getPhysicalFormats: Array<{ __typename?: 'PhysicalFormatDetails', id: number, name: string, dimensions: string, price: number, totalSupply: number, createdAt: string }> };

export type GetPhysicalOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<PhysicalOrderStatus>>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPhysicalOrdersQuery = { __typename?: 'Query', getPhysicalOrders: { __typename?: 'PhysicalOrderPage', currentPage: number, totalPages: number, orders: Array<{ __typename?: 'PhysicalOrder', id: number, userId: number, firstName: string, lastName: string, shippingAddress: string, shippingPrice: number, tax: number, createdAt: string, status: string, shippingInformation?: { __typename?: 'ShippingInformation', id: number, firstName: string, lastName: string, address: string, details: string, city: string, state: string, zip: string, country: string, phone?: string | null, taxCode?: string | null } | null, billingInformation?: { __typename?: 'BillingInformation', id: number, firstName: string, lastName: string, address: string, city: string, state: string, zip: string, country: string, phone?: string | null, taxCode?: string | null } | null, user?: { __typename?: 'User', id: number, username: string, email?: string | null } | null, items: Array<{ __typename?: 'PhysicalOrderItem', id: number, physicalId: number, quantity: number, physical?: { __typename?: 'Physical', id: number, title: string, price: number, format: PhysicalFormat, physicalFormat?: { __typename?: 'PhysicalFormatDetails', id: number, name: string, dimensions: string } | null, creator?: { __typename?: 'User', username: string } | null, imageUrls: Array<{ __typename?: 'PhysicalImage', imageUrl: string, width: number, height: number }> } | null }> }> } };


export const UpdateUserTypeDocument = gql`
    mutation UpdateUserType($id: Int!, $userType: String!) {
  updateUserType(id: $id, userType: $userType)
}
    `;
export const UpdateYomTypeDocument = gql`
    mutation UpdateYomType($id: Int!, $yomType: String!) {
  updateYomType(id: $id, yomType: $yomType)
}
    `;
export const HideNftDocument = gql`
    mutation HideNft($id: Int!, $hidden: Boolean!, $type: String!) {
  hideNft(id: $id, hidden: $hidden, type: $type)
}
    `;
export const UpdateUserGenreDocument = gql`
    mutation updateUserGenre($id: Int!, $genre: String) {
  updateUser(id: $id, genre: $genre) {
    id
  }
}
    `;
export const UpdateCanCreatePhysicalDocument = gql`
    mutation UpdateCanCreatePhysical($id: Int!, $canCreatePhysical: Boolean!) {
  updateUser(id: $id, canCreatePhysical: $canCreatePhysical) {
    id
    canCreatePhysical
  }
}
    `;
export const UpdateLabsPageDocument = gql`
    mutation updateLabsPage($id: Int!, $pageLink: String, $image: String, $assetType: String, $orientation: String) {
  updateLabsPage(
    id: $id
    pageLink: $pageLink
    image: $image
    assetType: $assetType
    orientation: $orientation
  )
}
    `;
export const CreateArticleDocument = gql`
    mutation createArticle($title: String!, $author: String!, $type: String!, $image1: String!, $image2: String, $artistId: Int, $body: String!, $excerpt: String!) {
  createArticle(
    title: $title
    author: $author
    type: $type
    image1: $image1
    image2: $image2
    artistId: $artistId
    body: $body
    excerpt: $excerpt
  )
}
    `;
export const UpdateArticleDocument = gql`
    mutation updateArticle($id: Int!, $title: String, $image1: String, $image2: String, $body: String, $excerpt: String) {
  updateArticle(
    id: $id
    title: $title
    image1: $image1
    image2: $image2
    body: $body
    excerpt: $excerpt
  )
}
    `;
export const DeleteArticleDocument = gql`
    mutation deleteArticle($id: Int!) {
  deleteArticle(id: $id)
}
    `;
export const UpdateCollectionDocument = gql`
    mutation updateCollection($id: Int!, $title: String, $description: String, $banner: String, $brutto: Boolean, $isCurrent: Boolean, $interview: Int, $article: Int, $pass: String, $isCompressed: Boolean) {
  updateCollection(
    id: $id
    title: $title
    description: $description
    banner: $banner
    brutto: $brutto
    isCurrent: $isCurrent
    interview: $interview
    article: $article
    pass: $pass
    isCompressed: $isCompressed
  ) {
    id
  }
}
    `;
export const EditPhysicalDocument = gql`
    mutation EditPhysical($id: Int!, $title: String, $description: String, $imageUrls: [PhysicalImageInput!], $totalSupply: Int, $availableSupply: Int, $price: Float, $onSale: Boolean, $isCurrent: Boolean, $formatId: Int, $status: PhysicalStatus) {
  editOnSale(
    id: $id
    title: $title
    description: $description
    imageUrls: $imageUrls
    totalSupply: $totalSupply
    availableSupply: $availableSupply
    price: $price
    onSale: $onSale
    isCurrent: $isCurrent
    formatId: $formatId
    status: $status
  )
}
    `;
export const CreatePhysicalDocument = gql`
    mutation CreatePhysical($title: String!, $description: String!, $creatorId: Int!, $totalSupply: Int, $availableSupply: Int, $price: Float, $formatId: Int, $imageUrls: [PhysicalImageInput!]!, $onSale: Boolean, $assetLink: String!) {
  createPhysical(
    title: $title
    description: $description
    creatorId: $creatorId
    totalSupply: $totalSupply
    availableSupply: $availableSupply
    price: $price
    formatId: $formatId
    imageUrls: $imageUrls
    onSale: $onSale
    assetLink: $assetLink
  )
}
    `;
export const SignInDocument = gql`
    query SignIn($walletAddress: String!) {
  user(walletAddress: $walletAddress) {
    username
    email
    userType
    walletAddress
  }
}
    `;
export const GetAuthenticatedUserDocument = gql`
    query GetAuthenticatedUser($userId: Int!) {
  userDetails(userId: $userId) {
    userId
    user {
      id
      username
      email
      userType
      walletAddress
    }
  }
}
    `;
export const SearchUsersDocument = gql`
    query SearchUsers($search: String!) {
  users(search: $search) {
    id
    walletAddress
    username
    email
    userType
    yomType
    twitter
    genre
    canCreatePhysical
  }
}
    `;
export const GetArtistsDocument = gql`
    query GetArtists {
  users(userType: [USER_TYPE_ARTIST]) {
    id
    walletAddress
    username
    email
    userType
    yomType
    twitter
    genre
    canCreatePhysical
  }
}
    `;
export const GetArtistDocument = gql`
    query GetArtist($id: Int!) {
  user(id: $id) {
    id
    username
    bio
  }
}
    `;
export const SearchArtworksDocument = gql`
    query SearchArtworks($search: String!) {
  searchNfts(search: $search) {
    id
    title
    description
    tokenId
    contractAddress
    standard
    platform
    price
    listingType
    listedOn
    hiddenByOGCreator
    status
    imageUrl
    assetType
    width
    height
    isCompressed
    ogCreator {
      id
      username
      userType
      walletAddress
    }
    trades {
      id
      price
      amount
    }
  }
}
    `;
export const GetTradesDocument = gql`
    query GetTrades {
  trades(orderBy: "createdAt DESC") {
    id
    nftId
    tokenId
    contractAddress
    nft {
      title
    }
    sellerId
    sellerAddress
    seller {
      username
      email
      legacyId
      details {
        firstName
        lastName
        type
        dob
        nationality
        region
        city
        street
        postalCode
        taxId
        vatNumber
        unicode
      }
    }
    price
    amount
    transactionHash
    sellerRevenue
    commissions
    ninfaFee
    royaltyFee
    isSecondary
    ethToUsd
    eurToUsd
    platform
    network
    tradeType
    createdAt
    carlo
    brando
    lorenzo
  }
}
    `;
export const GetChartsDataDocument = gql`
    query GetChartsData {
  trades(orderBy: "createdAt DESC", isVolume: true) {
    price
    ninfaFee
    ethToUsd
    amount
    createdAt
    network
    carlo
    brando
    lorenzo
  }
  users(
    orderBy: "createdAt DESC"
    userType: [USER_TYPE_COLLECTOR, USER_TYPE_ARTIST]
  ) {
    userType
    createdAt
    approvedAt
  }
  collections {
    type
    createdAt
  }
}
    `;
export const GetLabsDocument = gql`
    query getLabs {
  labs {
    id
    screen
    pageLink
    image
    assetType
    orientation
  }
}
    `;
export const GetArticlesDocument = gql`
    query GetArticles($limit: Int, $offset: Int, $title: String, $type: String) {
  articles(limit: $limit, offset: $offset, title: $title, type: $type) {
    currentPage
    totalPages
    articles {
      id
      title
      author
      image1
      image2
      type
      createdAt
      excerpt
      artist {
        profileImage
        username
      }
    }
  }
}
    `;
export const GetArticleDocument = gql`
    query GetArticle($id: Int!) {
  article(id: $id) {
    id
    title
    author
    image1
    image2
    type
    artistId
    body
    createdAt
    artist {
      profileImage
      username
    }
    excerpt
  }
}
    `;
export const GetCollectionsDocument = gql`
    query GetCollections {
  collections {
    id
    title
    description
    banner
    type
    ownerId
    network
    owner {
      username
      genre
    }
    createdAt
    contractAddress
    subdomain
    link
    interview
    article
    isCurrent
    brutto
    pass
    nftCount
    isCompressed
  }
}
    `;
export const GetPhysicalsPageDocument = gql`
    query GetPhysicalsPage($limit: Int, $offset: Int, $formatId: [Int], $status: [PhysicalStatus]) {
  getPhysicalsPage(
    limit: $limit
    offset: $offset
    formatId: $formatId
    status: $status
  ) {
    currentPage
    totalPages
    physicals {
      id
      title
      isCurrent
      creator {
        username
      }
      description
      totalSupply
      availableSupply
      price
      onSale
      format
      formatId
      physicalFormat {
        id
        name
        dimensions
        price
        totalSupply
        createdAt
      }
      status
      assetLink
      createdAt
      imageUrls {
        imageUrl
        width
        height
      }
    }
  }
}
    `;
export const SearchPhysicalDocument = gql`
    query SearchPhysical($search: String!) {
  searchPhysical(search: $search) {
    id
    title
    isCurrent
    creator {
      username
    }
    description
    totalSupply
    availableSupply
    price
    onSale
    format
    formatId
    physicalFormat {
      id
      name
      dimensions
      price
      totalSupply
      createdAt
    }
    status
    assetLink
    createdAt
    imageUrls {
      imageUrl
      width
      height
    }
  }
}
    `;
export const GetPhysicalDocument = gql`
    query GetPhysical($id: Int!) {
  getPhysical(id: $id) {
    id
    title
    isCurrent
    creatorId
    creator {
      username
    }
    description
    totalSupply
    availableSupply
    price
    onSale
    format
    formatId
    physicalFormat {
      id
      name
      dimensions
      price
      totalSupply
      createdAt
    }
    status
    assetLink
    createdAt
    imageUrls {
      imageUrl
      width
      height
    }
  }
}
    `;
export const GetPhysicalFormatsDocument = gql`
    query GetPhysicalFormats {
  getPhysicalFormats {
    id
    name
    dimensions
    price
    totalSupply
    createdAt
  }
}
    `;
export const GetPhysicalOrdersDocument = gql`
    query GetPhysicalOrders($limit: Int, $offset: Int, $status: [PhysicalOrderStatus!], $createdAtFrom: String, $createdAtTo: String) {
  getPhysicalOrders(
    limit: $limit
    offset: $offset
    status: $status
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
  ) {
    currentPage
    totalPages
    orders {
      id
      userId
      firstName
      lastName
      shippingAddress
      shippingPrice
      tax
      shippingInformation {
        id
        firstName
        lastName
        address
        details
        city
        state
        zip
        country
        phone
        taxCode
      }
      billingInformation {
        id
        firstName
        lastName
        address
        city
        state
        zip
        country
        phone
        taxCode
      }
      createdAt
      status
      user {
        id
        username
        email
      }
      items {
        id
        physicalId
        quantity
        physical {
          id
          title
          price
          format
          physicalFormat {
            id
            name
            dimensions
          }
          creator {
            username
          }
          imageUrls {
            imageUrl
            width
            height
          }
        }
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    UpdateUserType(variables: UpdateUserTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserTypeMutation>(UpdateUserTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserType', 'mutation');
    },
    UpdateYomType(variables: UpdateYomTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateYomTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateYomTypeMutation>(UpdateYomTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateYomType', 'mutation');
    },
    HideNft(variables: HideNftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HideNftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HideNftMutation>(HideNftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'HideNft', 'mutation');
    },
    updateUserGenre(variables: UpdateUserGenreMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserGenreMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserGenreMutation>(UpdateUserGenreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserGenre', 'mutation');
    },
    UpdateCanCreatePhysical(variables: UpdateCanCreatePhysicalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCanCreatePhysicalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCanCreatePhysicalMutation>(UpdateCanCreatePhysicalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCanCreatePhysical', 'mutation');
    },
    updateLabsPage(variables: UpdateLabsPageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateLabsPageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLabsPageMutation>(UpdateLabsPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLabsPage', 'mutation');
    },
    createArticle(variables: CreateArticleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateArticleMutation>(CreateArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createArticle', 'mutation');
    },
    updateArticle(variables: UpdateArticleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateArticleMutation>(UpdateArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateArticle', 'mutation');
    },
    deleteArticle(variables: DeleteArticleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteArticleMutation>(DeleteArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteArticle', 'mutation');
    },
    updateCollection(variables: UpdateCollectionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCollectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCollectionMutation>(UpdateCollectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCollection', 'mutation');
    },
    EditPhysical(variables: EditPhysicalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditPhysicalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditPhysicalMutation>(EditPhysicalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditPhysical', 'mutation');
    },
    CreatePhysical(variables: CreatePhysicalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePhysicalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePhysicalMutation>(CreatePhysicalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePhysical', 'mutation');
    },
    SignIn(variables: SignInQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SignInQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignInQuery>(SignInDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SignIn', 'query');
    },
    GetAuthenticatedUser(variables: GetAuthenticatedUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAuthenticatedUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAuthenticatedUserQuery>(GetAuthenticatedUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAuthenticatedUser', 'query');
    },
    SearchUsers(variables: SearchUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchUsersQuery>(SearchUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchUsers', 'query');
    },
    GetArtists(variables?: GetArtistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetArtistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArtistsQuery>(GetArtistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetArtists', 'query');
    },
    GetArtist(variables: GetArtistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetArtistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArtistQuery>(GetArtistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetArtist', 'query');
    },
    SearchArtworks(variables: SearchArtworksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchArtworksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchArtworksQuery>(SearchArtworksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchArtworks', 'query');
    },
    GetTrades(variables?: GetTradesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTradesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTradesQuery>(GetTradesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTrades', 'query');
    },
    GetChartsData(variables?: GetChartsDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetChartsDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetChartsDataQuery>(GetChartsDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetChartsData', 'query');
    },
    getLabs(variables?: GetLabsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLabsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLabsQuery>(GetLabsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLabs', 'query');
    },
    GetArticles(variables?: GetArticlesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArticlesQuery>(GetArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetArticles', 'query');
    },
    GetArticle(variables: GetArticleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArticleQuery>(GetArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetArticle', 'query');
    },
    GetCollections(variables?: GetCollectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCollectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCollectionsQuery>(GetCollectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCollections', 'query');
    },
    GetPhysicalsPage(variables?: GetPhysicalsPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPhysicalsPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPhysicalsPageQuery>(GetPhysicalsPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPhysicalsPage', 'query');
    },
    SearchPhysical(variables: SearchPhysicalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchPhysicalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchPhysicalQuery>(SearchPhysicalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchPhysical', 'query');
    },
    GetPhysical(variables: GetPhysicalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPhysicalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPhysicalQuery>(GetPhysicalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPhysical', 'query');
    },
    GetPhysicalFormats(variables?: GetPhysicalFormatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPhysicalFormatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPhysicalFormatsQuery>(GetPhysicalFormatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPhysicalFormats', 'query');
    },
    GetPhysicalOrders(variables?: GetPhysicalOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPhysicalOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPhysicalOrdersQuery>(GetPhysicalOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPhysicalOrders', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;